module.exports = __webpack_public_path__ + "img/marking_mounting_wedge_wired.2e06771e.png";